var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvancedApprovalsIconSquare = function SvgAdvancedApprovalsIconSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.66,
    height: 23.722,
    fill: "none",
    viewBox: "-0.647 -9.26 43.953 45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4ED7DE",
    d: "M41.368 21.485c0 1.213-.788 1.618-1.973 1.618H29.123c-1.258 0-1.975-.405-1.975-1.618 0-3.235 3.555-5.662 7.11-5.662 3.554 0 7.11 2.427 7.11 5.662ZM37.42 11.78c0 1.786-1.416 3.235-3.16 3.235-1.746 0-3.161-1.449-3.161-3.236 0-1.786 1.415-3.235 3.16-3.235s3.16 1.449 3.16 3.235Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    d: "M41.368 21.485c0 1.213-.788 1.618-1.973 1.618H29.123c-1.258 0-1.975-.405-1.975-1.618 0-3.235 3.555-5.662 7.11-5.662 3.554 0 7.11 2.427 7.11 5.662ZM37.42 11.78c0 1.786-1.416 3.235-3.16 3.235-1.746 0-3.161-1.449-3.161-3.236 0-1.786 1.415-3.235 3.16-3.235s3.16 1.449 3.16 3.235Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BA6A6",
    d: "M20.038 8.912c0 .717-.466.956-1.166.956h-6.07c-.743 0-1.167-.24-1.167-.956 0-1.912 2.1-3.346 4.201-3.346 2.1 0 4.202 1.434 4.202 3.346ZM17.704 3.176c0 1.056-.836 1.912-1.867 1.912-1.032 0-1.868-.856-1.868-1.912 0-1.055.836-1.911 1.868-1.911 1.031 0 1.867.856 1.867 1.911Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    d: "M20.038 8.912c0 .717-.466.956-1.166.956h-6.07c-.743 0-1.167-.24-1.167-.956 0-1.912 2.1-3.346 4.201-3.346 2.1 0 4.202 1.434 4.202 3.346ZM17.704 3.176c0 1.056-.836 1.912-1.867 1.912-1.032 0-1.868-.856-1.868-1.912 0-1.055.836-1.911 1.868-1.911 1.031 0 1.867.856 1.867 1.911Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BA6A6",
    d: "M20.038 22.147c0 .717-.466.956-1.166.956h-6.07c-.743 0-1.167-.239-1.167-.956 0-1.912 2.1-3.345 4.201-3.345 2.1 0 4.202 1.433 4.202 3.345ZM17.704 16.412c0 1.056-.836 1.912-1.867 1.912-1.032 0-1.868-.856-1.868-1.912s.836-1.912 1.868-1.912c1.031 0 1.867.856 1.867 1.912Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    d: "M20.038 22.147c0 .717-.466.956-1.166.956h-6.07c-.743 0-1.167-.239-1.167-.956 0-1.912 2.1-3.345 4.201-3.345 2.1 0 4.202 1.433 4.202 3.345ZM17.704 16.412c0 1.056-.836 1.912-1.867 1.912-1.032 0-1.868-.856-1.868-1.912s.836-1.912 1.868-1.912c1.031 0 1.867.856 1.867 1.912Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#28736D",
    d: "M6.464 7.22c0 .497-.323.662-.807.662H1.455c-.515 0-.809-.165-.809-.661 0-1.324 1.455-2.317 2.91-2.317 1.453 0 2.908.993 2.908 2.317ZM4.848 3.25c0 .731-.578 1.324-1.292 1.324-.714 0-1.293-.593-1.293-1.324 0-.731.579-1.324 1.293-1.324s1.292.593 1.292 1.324Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    d: "M6.464 7.22c0 .497-.323.662-.807.662H1.455c-.515 0-.809-.165-.809-.661 0-1.324 1.455-2.317 2.91-2.317 1.453 0 2.908.993 2.908 2.317ZM4.848 3.25c0 .731-.578 1.324-1.292 1.324-.714 0-1.293-.593-1.293-1.324 0-.731.579-1.324 1.293-1.324s1.292.593 1.292 1.324Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#28736D",
    d: "M6.464 20.456c0 .496-.323.662-.807.662H1.455c-.515 0-.809-.166-.809-.662 0-1.324 1.455-2.316 2.91-2.316 1.453 0 2.908.992 2.908 2.316ZM4.848 16.485c0 .731-.578 1.324-1.292 1.324-.714 0-1.293-.593-1.293-1.324 0-.73.579-1.323 1.293-1.323s1.292.592 1.292 1.323Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    d: "M6.464 20.456c0 .496-.323.662-.807.662H1.455c-.515 0-.809-.166-.809-.662 0-1.324 1.455-2.316 2.91-2.316 1.453 0 2.908.992 2.908 2.316ZM4.848 16.485c0 .731-.578 1.324-1.292 1.324-.714 0-1.293-.593-1.293-1.324 0-.73.579-1.323 1.293-1.323s1.292.592 1.292 1.323Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#03D47C",
    d: "m34.77 20.203-.975 1.498s1.732-.025 4.95 3.27c0 0 1.145-6.191 4.534-9.935l-.146-.2-1.317-.599s-2.584 2.82-3.852 7.764c0 0-1.633-1.548-3.194-1.798Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M41.844 14.215c-1.157 1.046-3.497 5.348-3.904 7.793-.165-.163-.99-1.115-3.234-1.889-.085.143-.813 1.39-.903 1.523 2.056.266 4.885 3.195 4.974 3.345.643-3.802 2.845-8.504 4.53-10.007-.193-.103-1.299-.655-1.463-.766v0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#03D47C",
    d: "m17.058 8.869-.377.577s.668-.01 1.91 1.262c0 0 .441-2.388 1.748-3.832l-.056-.077-.508-.231s-.997 1.088-1.486 2.994c0 0-.63-.597-1.232-.693Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.48 7.63a9.379 9.379 0 0 0-.483 1.093 4.593 4.593 0 0 0-.801-.36.5.5 0 0 0-.594.219l-.045.076-.128.22-.11.184-.047.078-.002.005a.5.5 0 0 0 .35.775c.107.013.259.069.448.176.183.103.372.239.547.38a6.486 6.486 0 0 1 .59.542.5.5 0 0 0 .891-.22c.115-.682.374-1.46.684-2.138.319-.696.659-1.215.903-1.433a.5.5 0 0 0-.098-.814l-.155-.08a48.66 48.66 0 0 1-.36-.187.5.5 0 0 0-.633.055 3.382 3.382 0 0 0-.47.59c-.161.244-.33.535-.487.84Zm-.265 3.398a.07.07 0 0 1-.005-.006l.005.006Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#03D47C",
    d: "m17.058 22.104-.377.578s.668-.01 1.91 1.261c0 0 .441-2.388 1.748-3.832l-.056-.077-.508-.23s-.997 1.087-1.486 2.994c0 0-.63-.597-1.232-.694Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.48 20.866a9.386 9.386 0 0 0-.483 1.092 4.59 4.59 0 0 0-.801-.359.5.5 0 0 0-.594.218l-.045.077-.128.22-.11.183-.047.079-.002.004a.5.5 0 0 0 .35.775c.107.014.259.07.448.176.183.104.372.239.547.38a6.486 6.486 0 0 1 .565.514l.026.028a.5.5 0 0 0 .89-.22c.115-.682.374-1.46.684-2.138.319-.696.659-1.214.903-1.432a.5.5 0 0 0-.098-.815l-.155-.08a36.754 36.754 0 0 1-.364-.188.5.5 0 0 0-.63.056 3.381 3.381 0 0 0-.469.59 9.32 9.32 0 0 0-.487.84Zm-.265 3.397-.005-.006.005.006Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0164BF",
    d: "m9.96 4.221.036.722 1.412-1.094-1.513-.972.038.785"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0164BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.96 4.221.036.722 1.412-1.094-1.513-.972.038.785"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0164BF",
    d: "m9.962 4.185-1.865.034H8.03L8 3.689l1.94-.016"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0164BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.962 4.185-1.865.034H8.03L8 3.689l1.94-.016"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0164BF",
    d: "m9.96 17.457.036.721 1.412-1.094-1.513-.972.038.785"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0164BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.96 17.457.036.721 1.412-1.094-1.513-.972.038.785"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#0164BF",
    d: "m9.962 17.42-1.865.034H8.03l-.03-.53 1.94-.015"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0164BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.962 17.42-1.865.034H8.03l-.03-.53 1.94-.015"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#0164BF",
    d: "m24.596 15.44.735 1.163 1.32-3.204-3.424-.129.799 1.266"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0164BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24.596 15.44.735 1.163 1.32-3.204-3.424-.129.799 1.266"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0164BF",
    d: "m24.564 15.378-3.066 1.886-.111.066-.546-.852 3.206-1.929"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0164BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24.564 15.378-3.066 1.886-.111.066-.546-.852 3.206-1.929"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#0164BF",
    d: "m24.596 5.7.735-1.163 1.32 3.204-3.424.129.799-1.266"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0164BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24.596 5.7.735-1.163 1.32 3.204-3.424.129.799-1.266"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#0164BF",
    d: "m24.564 5.762-3.066-1.886-.111-.066-.546.852 3.206 1.929"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0164BF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24.564 5.762-3.066-1.886-.111-.066-.546.852 3.206 1.929"
  })));
};
export default SvgAdvancedApprovalsIconSquare;